import {useState} from 'react';


const useForm = ({initialState, onSubmitHandler,validate}) => {
    const [form, setForm] = useState(initialState || {});
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [touched, setTouched] = useState({});

    const handleChange = (e) => {
        
        const newState = {
            ...form,
            [e.target.name]: e.target.value
        }
        setForm(newState);
        setErrors(validate?.(newState));
    }
    const handleBlur = (e) => {
        setTouched({
            ...touched,
            [e.target.name]: true
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        await onSubmitHandler?.(form, {resetValues,errors, setIsSubmitting, setErrors});
        // setIsSubmitting(false)
    }
    const resetValues = () => {
        setForm({});
    }
    const isValid = () => {
        const newErrors = {};
        Object.keys(form).forEach(key => {
            if(!form[key]){
                newErrors[key] = "This field is required";
            }   
        })  
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    const handleUpdate = () => (
        {
            onChange: handleChange,
            onBlur: handleBlur,
        }
    )
    return {
        values: form,
        errors,
        isSubmitting,
        handleChange,
        handleSubmit,
        isValid,
        handleBlur,
        touched,
        setValues: setForm,
        handleUpdate,
    }
}

export default useForm;